import PropTypes from "prop-types";
import React from "react";

const ServiceOneSingle = ({ data, styles }) => {
  return (
    <div className="col-12 col-md-6 col-lg-4 md__mt--40 sm__mt--40">
      <div className={styles.service}>
        <img
          src={require("./../../../assets/images/icons/" + data.icon)} class="rounded mx-auto d-block"
          alt="HT-Call voip"
        />
        <h2 class="text-center">{data.title}</h2>
        <p>{data.text}</p>
        <p>{data.text2}</p>
        <p>{data.text3}</p>
        <p>{data.text4}</p>

      </div>
    </div>
  );
};

ServiceOneSingle.propTypes = {
  data: PropTypes.object,
  styles: PropTypes.object
};

export default ServiceOneSingle;
